console.log("Vite ⚡️ Rails");

import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";

import BatchMessageController from "../controllers/batch_message_controller";
import BatchPreviewController from "../controllers/batch_preview_controller";
import DropdownController from "../controllers/dropdown_controller";

const application = Application.start();
application.register("batch-message", BatchMessageController);
application.register("batch-preview", BatchPreviewController);
application.register("dropdown", DropdownController);
